import React,{useState} from 'react'
import { FileUploader } from "react-drag-drop-files";
import Progress from 'react-progressbar';
import {
    FormControl,
    RadioGroup,
    Radio,
    FormControlLabel,
  } from "@mui/material";
import { CancelIcon } from '../../assets/Icons';
import Releases from './Releases';

const LauncherFiles = () => {


    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false)
    const handleChangeUploadFile = (file) => {
        // console.log('File selected:', file);
    };
    const fileTypes = ["Video", "PDF", "PPT"];

  return (
    <>
    <div className='row'>
        <div className='col-lg-7'>
           <div className='standardinput '>
                  <label> Select Platform <span>*</span> </label>
                
                <FormControl fullWidth className="mb-0 mt-2 pt-0 d-flex align-items-start">
                  <RadioGroup
                    row
                    aria-labelledby="price-visibility-label"
                    name="mobile"
                    className="gap-3"
                    value="mobile" 
                  >
                    <FormControlLabel
                      className="quizlabel"
                      value="mobile"
                      control={<Radio />}
                      label="Mobile"
                    />
                    <FormControlLabel
                      className="quizlabel"
                      value="standalone"
                      control={<Radio />}
                      label="Standalone VR"
                    />
                    <FormControlLabel
                      className="quizlabel"
                      value="desktop"
                      control={<Radio />}
                      label="Desktop"
                    />
              
                  </RadioGroup>
                </FormControl>
            </div>
            <div className="DragDropMenu uploadfilesss mt-3">
                <div className='fileuploader'>
                    <FileUploader
                        handleChange={handleChangeUploadFile}
                        label="drag & drop or choose file to upload"
                        name="file"
                        // types={fileTypes}
                    >
                        <span className='upload-box-info'>
                            drag & drop or choose file to upload
                        </span>
                    </FileUploader>
                </div>
            </div>

            <div className="uploadstatus">
                <div className="upperdiv">
                 <div className="uploaddata"> 
                    <div className="xr">
                        <p>uploadFile.name</p>   
                        <span className='cancel-btn' style={{ cursor: "pointer", lineHeight: '1' }}>
                            <CancelIcon/>
                        </span>
                    </div>
                    <div className=" xr mb-1">
                        <p className="filesize">10mb </p>
                        <p className="filesize">50%</p>
                    </div>
                    <Progress completed="50%" />
                 </div>
                </div>
            </div>
            <p className='basicDetailError'> Error in file upload. try again </p>

            <div className="standardinput">
                <label>Version <span>*</span> </label>
                <input
              autoComplete="off"
              name="machineName"
              id="machineName"
              className="input form-control"
              type="text"
            />
            </div>

            <div className="mb-3 mt-2 VComment standardinput">
                <label htmlFor="exampleFormControlTextarea1" className="form-label">Comment <span>*</span></label>
                <textarea value={comment}  className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                <p className='uploadAssetsError'>uploadError</p>
            </div>

            <div className="footerbtn" >
                <button className='save'>Save</button>
                <button className='loading save'>
                <svg viewBox="25 25 50 50">
                    <circle r="20" cy="50" cx="50"></circle>
                </svg>
                </button>
            </div>
        </div>
        <div className='col-lg-5'>
            <div className='standardinput pb-3'>
            <label> Latest File </label>
            </div>
            <div className='cardstyle'>
                <div className="deploybtn d-flex justify-content-between">
                <div>
                    <div className='popupselect fortype'>
                        <p className='mb-0'> 1 month ago </p>
                    </div>
                </div>
                </div>
                <div className='filedetails'>
                    <p>Version :<span>2.5</span></p>
                    <p>Asset :<span><a download>File.zip</a></span></p>
                    <p>Uploaded By :<span>Ritik Sahni</span></p>
                    <p>Timestamp :<span>June 20th 2024, 7:03 pm</span></p>
                    <span className='versionlistv'>Change in blockable, walkable, Video material and Audio source</span>
                </div>
            </div>
        </div>
    </div>
    <Releases/>
    </>
  )
}

export default LauncherFiles
